// Components==============
import { ChannelType } from 'pages/Workspace/ProjectDetails/components/Communication/Communication';
import { ProjectDetailsContext } from 'pages/Workspace/ProjectDetails/ProjectDetails';
import { useContext } from 'react';
import useGenerateEventName from './useGenerateEventName';
import { useRedux } from './useRedux';
// =========================

export function useUnreadCount(notifications: { [key: string]: number }) {
  const { project } = useContext(ProjectDetailsContext);

  const generateEventName = useGenerateEventName();

  const notificationEntities = useRedux((state) =>
    state.notification?.entities.allIds
      .map((id) => state.notification?.entities.byId[id])
      .filter(
        (n) =>
          n?.target &&
          ('project_id' in n.target ? n.target.project_id : n.target.id) ===
            project?.id
      )
  );

  const getUnreadCount = (channel: ChannelType) => {
    const channelNotifications =
      notificationEntities?.filter((n) => n?.target_id === channel.id).length ||
      0;

    const realTimeNotifications =
      notifications[generateEventName(channel?.type, channel?.id)] || 0;

    return channelNotifications + realTimeNotifications;
  };

  return getUnreadCount;
}
